import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';
import type { ApprovalView } from '@/shared/api/types';

export function useApprovalView(token: string) {
  return useQuery({
    queryKey: ['approval', token],
    queryFn: () => api<ApprovalView>(`/api/freigabe/${token}`, { auth: false }),
    retry: false,
  });
}

export interface DecideInput {
  decision: 'CONFIRMED' | 'REJECTED';
  items?: { extraServiceId: string; decision: 'CONFIRMED' | 'REJECTED' }[];
  comment?: string;
  decidedByName?: string;
}

export function useDecide(token: string) {
  return useMutation({
    mutationFn: (input: DecideInput) =>
      api<{ decision: string; decidedAt: string; message: string }>(
        `/api/freigabe/${token}/decide`,
        { method: 'POST', auth: false, body: input },
      ),
  });
}
